import { API_URL } from '@/lib/apiConfig';
import { isNativeApp } from './native';


function getInstallationId() {
  let id = localStorage.getItem('push_installation_id');
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem('push_installation_id', id);
  }
  return id;
}

function getPlatform() {
  const platform = window.Capacitor?.getPlatform?.();
  if (platform === 'ios') return 'ios';
  if (platform === 'android') return 'android';
  return null;
}

export async function checkPushPermissionStatus() {
  if (!isNativeApp()) return 'denied';
  try {
    const { PushNotifications } = await import('@capacitor/push-notifications');
    const result = await PushNotifications.checkPermissions();
    return result.receive; // 'granted' | 'denied' | 'prompt' | 'prompt-with-rationale'
  } catch {
    return 'denied';
  }
}

export async function requestPushPermission() {
  if (!isNativeApp()) return false;

  const platform = getPlatform();
  if (!platform) return false;

  try {
    const { PushNotifications } = await import('@capacitor/push-notifications');

    const permResult = await PushNotifications.requestPermissions();
    if (permResult.receive !== 'granted') return false;

    await PushNotifications.register();

    PushNotifications.addListener('registration', async (token) => {
      const installationId = getInstallationId();
      try {
        await fetch(`${API_URL}/api/push/register`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify({
            device_token: token.value,
            platform,
            installation_id: installationId,
          }),
        });
      } catch (err) {
        console.error('Push registration failed:', err);
      }
    });

    PushNotifications.addListener('registrationError', (err) => {
      console.error('Push registration error:', err);
    });

    PushNotifications.addListener('pushNotificationReceived', () => {
      window.__queryClient?.invalidateQueries({ queryKey: ['notifications'] });
    });

    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      const data = action.notification?.data;
      const url = data?.action_url;
      if (url && window.__navigate) {
        window.__navigate(url);
      }
    });

    return true;
  } catch (err) {
    console.error('Push init error:', err);
    return false;
  }
}

export async function unregisterPush() {
  if (!isNativeApp()) return;

  const installationId = localStorage.getItem('push_installation_id');
  if (!installationId) return;

  try {
    await fetch(`${API_URL}/api/push/unregister`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({ installation_id: installationId }),
    });
  } catch (err) {
    console.error('Push unregister failed:', err);
  }
}
